import { render, staticRenderFns } from "./LatestPublicationListClassic.vue?vue&type=template&id=5b6d17ff"
import script from "./LatestPublicationListClassic.vue?vue&type=script&lang=js"
export * from "./LatestPublicationListClassic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports